module.exports = __webpack_public_path__ + "media/images/icons/loading_white-e8281db73072d6bc5a5f19c932597371.svg";